export default __webpack_public_path__ + "static/media/template_05.2d49baef.jpg";